import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: null,
    currentStartDate: new Date(),
    currentEndDate: new Date(),
    clientNotifications: [],
  },
  mutations: {
    updateState(state, data){
      state[data.state] = data.body
    },
    addClientNotification(state, notification) {
      state.clientNotifications.unshift(notification);
      if (state.clientNotifications.length > 50) state.clientNotifications.pop();
    },
    clearClientNotifications(state) {
      state.clientNotifications = [];
    },
    removeClientNotification(state, idx) {
      state.clientNotifications.splice(idx, 1);
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: [vuexLocal.plugin]
})
